module.exports = __webpack_public_path__ + "img/horizontal_7_1_8019.617943b4.png";